'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queue = require('./queue');

var _queue2 = _interopRequireDefault(_queue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var account = _ref.account;
  var environment = _ref.environment;
  var _ref$maxQueueSize = _ref.maxQueueSize;
  var maxQueueSize = _ref$maxQueueSize === undefined ? 200 : _ref$maxQueueSize;

  var initialise = function initialise() {
    if (typeof window !== 'undefined') {
      // required for utag to work
      window.utag_data = {}; // eslint-disable-line camelcase

      // prevents utag from sending a 'view' event on page load
      window.utag_cfg_ovrd = { noview: true }; // eslint-disable-line camelcase
    }
  };

  var scriptTag = '<script async src="https://tags.tiqcdn.com/utag/' + account + '/' + environment + '/utag.js"></script>';

  var queue = (0, _queue2.default)({ max: maxQueueSize });

  var track = function track(type) {
    var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    if (typeof window === 'undefined') {
      return;
    }

    if (window.ANALYTICS_DEBUG) {
      console.log({ adapter: 'tealium', type: type, props: props }); // eslint-disable-line no-console
    }

    var _window = window;
    var utag = _window.utag;


    if (typeof utag !== 'undefined' && typeof utag.track === 'function') {
      if (queue.size() > 0) {
        queue.dequeueAll(function (_ref2) {
          var eventType = _ref2.eventType;
          var eventProps = _ref2.eventProps;
          return utag.track(eventType, eventProps);
        });
      }

      utag.track(type, _extends({}, props));
    } else {
      queue.enqueue({ type: type, props: props });
    }
  };

  var link = function link(eventName) {
    var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    return track('link', _extends({ eventName: eventName }, props));
  };

  var view = function view(pageName) {
    var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    return track('view', _extends({ pageName: pageName }, props));
  };

  initialise();

  return {
    link: link,
    view: view,
    scriptTag: scriptTag
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/adapters/tealium/index.js
 ** module id = 407
 ** module chunks = 0
 **/